import './PreventaMobile.css'; 
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useParams } from 'react-router-dom';
import { IdentifyClient } from './IdentifyClient';
import { ProductPicker } from './ProductPicker';
import { SelectedProducts } from './SelectedProducts';
import { FindPrecioEspecial, FindPrecioFamiliar, FindPrecioMenor, FindPrecioPorMayor, GetPrecioCosto, getPrecioPorMayor } from '../Preventas/PreciosPreventa';
import { calcTotal, calcularTotales,formatSoles } from '../../Global';
import { isNumber } from 'lodash';
import { notificarMsg } from '../Almacenes/AlmacenNotify';


function PreventaMobile(props) {  
  const [buscarProducto, setBuscarProducto] = useState('');
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [totales, setTotales] = useState({});
  const [client, setClient] = useState(null);
  const [alias, setAlias] = useState("");
  const { IdPreventa: IdPreventaParam } = useParams();
  const IdPreventa = props.match?.params?.IdPreventa || IdPreventaParam;
  const isEdit = !!IdPreventa;
  const ignoreClientUpdatesRef = useRef(isEdit);
  const lastClientIdRef = useRef(null);

  useEffect(() => {
    const _calculated = calcularTotales(selectedProducts);
    
    setTotales({
        Gravado: _calculated.gravados,
        Inafecto: _calculated.inafectos,
        Exonerado: _calculated.exonerados,
        IGVPreventa: _calculated.igvVenta,
        Gratuitas: _calculated.gratuitos,
        totalMonto: _calculated.total,
        ICBPERPreventa: _calculated.icbper,
        redondeo: _calculated.redondeo,
    });
}, [selectedProducts]);

  useEffect(() => {
    if (!isEdit) return;
    let isActive = true;

    const fetchPreventa = async () => {
      try {
        const preventaReq = await fetch(`/api/gestionPreventas/preventa/${IdPreventa}`);
        if (!preventaReq.ok) {
          throw new Error("No se pudo cargar la preventa");
        }
        const preventa = await preventaReq.json();
        const preventaInfo = preventa?.respuesta?.[0];
        if (preventaInfo && isActive) {
          setAlias(preventaInfo.Alias || "");
          if (preventaInfo.NroTipoDocumento) {
            const clientReq = await fetch(`/api/preVentas/traerCliente/${preventaInfo.NroTipoDocumento}`);
            if (clientReq.ok) {
              const clientData = await clientReq.json();
              if (Array.isArray(clientData) && clientData[0]) {
                setClient(clientData[0]);
              }
            }
          }
        }

        const detalleReq = await fetch(`/api/gestionPreventas/detallepreventa/${IdPreventa}`);
        if (!detalleReq.ok) {
          throw new Error("No se pudo cargar el detalle de la preventa");
        }
        const detalle = await detalleReq.json();
        const detalleItems = Array.isArray(detalle?.respuesta) ? detalle.respuesta : [];
        const mappedDetails = detalleItems.map((dp) => {
          const detail = {
            ...dp,
            Cantidad: dp.Cantidad,
            Descuento: dp.Descuento,
            PrecioVenta: dp.PrecioVenta,
            PrecioReferencial: dp.PrecioReferencial ?? dp.Precio ?? dp.PrecioVenta,
            Precio: dp.Precio ?? dp.PrecioVenta,
            PrecioEspecial: FindPrecioEspecial([], dp),
            PrecioFamiliar: FindPrecioFamiliar([], dp),
            PrecioCosto: GetPrecioCosto([], dp),
            PrecioMenor: FindPrecioMenor([], dp),
            precioMayor: getPrecioPorMayor([], dp),
            checked: isNumber(dp.checked) ? dp.checked : (dp.Gratuito === 1 ? 1 : 0),
            oldPrecios: [dp.PrecioVenta],
            initialAfectGrat: dp.IdAfectacionIgv,
            oldCants: [dp.Cantidad],
            NombreProducto: dp.NombreProducto || dp.descripcion || dp.Nombre
          };
          detail.Total = calcTotal(detail) - detail.Descuento;
          return detail;
        });
        if (isActive) {
          setSelectedProducts(mappedDetails);
          ignoreClientUpdatesRef.current = false;
        }
      } catch (error) {
        console.error(error);
        alert("Ocurrió un error al cargar la preventa");
      }
    };

    fetchPreventa();

    return () => {
      isActive = false;
    };
  }, [IdPreventa, isEdit]);

  const updatePreventaMontoInDB = async (totalMonto) => {
    if (!isEdit) return;
    try {
      await fetch(`/api/preVentas/PreventaUpdateMonto/${IdPreventa}`, {
        method: "PUT",
        body: JSON.stringify({ Total: totalMonto }),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  const updatePreventaClienteInDB = useCallback(async (idCliente) => {
    if (!isEdit) return;
    try {
      await fetch(`/api/preVentas/PreventaUpdateCliente/${IdPreventa}`, {
        method: "PUT",
        body: JSON.stringify({ IdCliente: idCliente }),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      });
    } catch (error) {
      console.error(error);
    }
  }, [IdPreventa, isEdit]);

  const handleChangeClient = useCallback((nextClient) => {
    if (ignoreClientUpdatesRef.current) return;

    setClient((prevClient) => {
      if (prevClient?.IdCliente === nextClient?.IdCliente) {
        return prevClient;
      }
      return nextClient;
    });

    if (nextClient?.IdCliente && lastClientIdRef.current !== nextClient.IdCliente) {
      lastClientIdRef.current = nextClient.IdCliente;
      updatePreventaClienteInDB(nextClient.IdCliente);
    }
  }, [updatePreventaClienteInDB]);

  const updateDetallePreventaInDB = async (item) => {
    if (!isEdit || !item?.IdDetallePreventa) return;
    try {
      await fetch(`/api/preVentas/editDet/${item.IdDetallePreventa}`, {
        method: "PUT",
        body: JSON.stringify({
          IdPreventa: IdPreventa,
          IdStock: item.IdStock,
          IdPresentacion: item.IdPresentacion,
          Cantidad: item.Cantidad,
          Total: item.Total,
          PrecioVenta: item.PrecioVenta,
          Precio: item.PrecioReferencial,
          ValorUnitario: item.ValorUnitario,
          Descuento: item.Descuento,
          Gratuito: item.Gratuito,
          IdAfectacionIgv: item.IdAfectacionIgv
        }),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  const addDetallePreventaInDB = async (item) => {
    if (!isEdit) return null;
    try {
      const res = await fetch("/api/preVentas/addDetalle", {
        method: "POST",
        body: JSON.stringify({
          IdPreventa: IdPreventa,
          Cantidad: item.Cantidad,
          Total: item.Total,
          IdStock: item.IdStock,
          IdPresentacion: item.IdPresentacion,
          IdAfectacionIgv: item.IdAfectacionIgv,
          Descuento: 0,
          PrecioReferencial: item.Precio,
          PrecioVenta: item.PrecioVenta,
          TipoCambio: item.TipoCambio,
          IdAlmacen: item.IdAlmacen,
          ValorUnitario: item.ValorUnitario
        }),
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      });
      if (!res.ok) return null;
      const json = await res.json();
      return json?.respuesta ?? null;
    } catch (error) {
      console.error(error);
      return null;
    }
  };

  const removeDetallePreventaInDB = async (item) => {
    if (!isEdit || !item?.IdDetallePreventa) return;
    try {
      await fetch(`/api/preVentas/deleteDetPreVenta/${item.IdDetallePreventa}?idPreventa=${IdPreventa}`, {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      });
    } catch (error) {
      console.error(error);
    }
  };

  const updateTotalFromItems = async (items) => {
    if (!isEdit) return;
    const calculated = calcularTotales(items);
    await updatePreventaMontoInDB(calculated.total);
  };

  const onChooseProduct = async (...products) => {
    let currentItems = [...selectedProducts];

    for (const product of products) {
        const i = currentItems.indexOfObject(product, "IdPresentacion");

        if (i !== -1) {
            const oldQuantity = currentItems[i].Cantidad;
            const oldDescuento = currentItems[i].Descuento;
            const perUnitDescuento = oldDescuento / oldQuantity;

            currentItems[i].Cantidad = currentItems[i].Cantidad + ('Cantidad' in product ? product.Cantidad : 1);
            currentItems[i].Descuento = perUnitDescuento * currentItems[i].Cantidad;
            FindPrecioPorMayor([], currentItems[i])
            currentItems[i].Total = calcTotal(currentItems[i]) - currentItems[i].Descuento
            await updateDetallePreventaInDB(currentItems[i]);
        } else {
            FindPrecioPorMayor([], product);
            
            const detail = {
                ...product,
                Cantidad: product.Cantidad || 1,
                Descuento: product.Descuento * (product.Cantidad || 1),
                PrecioVenta: product.PrecioVenta,
                PrecioEspecial: FindPrecioEspecial([], product),
                PrecioFamiliar: FindPrecioFamiliar([], product),
                PrecioCosto: GetPrecioCosto([], product),
                PrecioMenor: FindPrecioMenor([], product),
                precioMayor: getPrecioPorMayor([], product),
                checked: isNumber(product.checked) ? product.checked : 0,
                oldPrecios: [product.PrecioVenta],
                initialAfectGrat: product.IdAfectacionIgv,
                oldCants: [1],
                NombreProducto: product.descripcion
            }

            detail.Total = calcTotal(detail) - detail.Descuento

            currentItems.push(detail);
            if (isEdit) {
              const newId = await addDetallePreventaInDB(detail);
              if (newId) {
                detail.IdDetallePreventa = newId;
              }
            }
        }

    }

    setSelectedProducts([...currentItems]);
    await updateTotalFromItems(currentItems);
  };

  const onChangeProductQuantity = async (index, action) => {
    let currentItems = [...selectedProducts];

    const oldQuantity = currentItems[index].Cantidad;
    const oldDescuento = currentItems[index].Descuento;
    const perUnitDescuento = oldDescuento / oldQuantity;

    if (action == 'subtract' && oldQuantity <= 1) {
      return;
    }

    let newQuantity = 0;

    if (action == 'subtract') {
      newQuantity -= 1;
    } else if (action == 'add') {
      newQuantity += 1;
    }

    currentItems[index].Cantidad = currentItems[index].Cantidad + newQuantity;
    currentItems[index].Descuento = perUnitDescuento * currentItems[index].Cantidad;
    FindPrecioPorMayor([], currentItems[index])
    currentItems[index].Total = calcTotal(currentItems[index]) - currentItems[index].Descuento

    setSelectedProducts([...currentItems]);
    await updateDetallePreventaInDB(currentItems[index]);
    await updateTotalFromItems(currentItems);
  }

  const onRemoveProduct = async (index) => {
    const itemToRemove = selectedProducts[index];
    let currentItems = [...selectedProducts].filter((_, idx) => idx != index);
    setSelectedProducts([...currentItems]);
    await removeDetallePreventaInDB(itemToRemove);
    await updateTotalFromItems(currentItems);
  }

  const onGenerate = async () => {
    if (isEdit) {
      await updateTotalFromItems(selectedProducts);
      props.history.push(`/pagos/${IdPreventa}`)
      return;
    }
    const payload = {
      detalles: selectedProducts.map((item) => ({
          IdPresentacion: item.IdPresentacion,
          IdProducto: item.IdProducto,
          EsFacturable: item.EsFacturable,
          ValorUnitario: item.ValorUnitario,
          Gratuito: item.Gratuito,
          Descuento: item.Descuento,
          IdAfectacionIgv: item.IdAfectacionIgv,
          IdStock: item.IdStock,
          IdTipoStock: item.IdTipoStock,
          Precio: item.Precio,
          TipoCambio: item.TipoCambio,
          IdAlmacen: item.IdAlmacen,
          PrecioReferencial: item.PrecioReferencial,
          PrecioVenta: item.PrecioVenta,
          Cantidad: item.Cantidad,
          Total: item.Total,
      })),
      IdTipoDocumentoSunat: 1,
      IdCliente: client.IdCliente,
      Total: totales.totalMonto,
      alias: alias,
    };

    const req = await fetch("/api/pre-invoice/add/v2", {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
            'Content-Type': 'application/json'
        }
    })

    if (!req.ok) {
        alert("Ocurrió un error al registrar el pedido")

        return;
    }

    const data = await req.json();

    notificarMsg("Se ha realizado con éxito");
    props.history.push(`/pagos/${data.IdPreventa}`)
  }

  const onPriceChange = async (index, newPrice) => {
    let currentItems = [ ...selectedProducts];
    currentItems[index].PrecioVenta = newPrice;
    currentItems[index].Total = calcTotal(currentItems[index]) - currentItems[index].Descuento;
    setSelectedProducts([...currentItems]);
    await updateDetallePreventaInDB(currentItems[index]);
    await updateTotalFromItems(currentItems);
  }

  const onSelectPrice = async (index, priceValue, priceName) => {
    let currentItems = [...selectedProducts];
    const product = currentItems[index];

    const precio = product.precio.find(p => p.NombrePrecio.includes(priceName));
    if(precio){
      product.PrecioVenta = precio.Precio;
      product.ValorUnitario = precio.ValorUnitario;
      product.Total = calcTotal({Cantidad: product.Cantidad, PrecioVenta: product.PrecioVenta});
      product.PrecioReferencial = parseFloat(product.PrecioVenta);

      setSelectedProducts([...currentItems]);
      await updateDetallePreventaInDB(product);
      await updateTotalFromItems(currentItems);
    }
  };

  const onSecretKeyPress = async (index) => {
    let currentItems = [...selectedProducts];
    const product = currentItems[index];
    if (product.precioMayor) {
      product.PrecioVenta = product.precioMayor.Precio;
      product.Total = calcTotal(product) - product.Descuento;
      setSelectedProducts([...currentItems]);
      await updateDetallePreventaInDB(product);
      await updateTotalFromItems(currentItems);
    }
  };

  const isGreaterThanZero = (value) => {
    return typeof value === 'number' && value > 0;
  };


  return (
    <div>
      <div className='abed-preventa__container'>
        <IdentifyClient onChangeClient={handleChangeClient} initialClient={client} isEdit={isEdit}/>
        <div className='abed-ingresar_cliente'> 
            <input className='abed-DocCliente' type="text" placeholder='ALIAS' value={alias} onChange={e => setAlias(e.target.value)}/>
        </div>
      </div>

      <section className="section-rigth">
        <SelectedProducts
          products={selectedProducts}
          onSubtractQuantity={index => onChangeProductQuantity(index, 'subtract')}
          onAddQuantity={index => onChangeProductQuantity(index, 'add')}
          onRemoveProduct={index => onRemoveProduct(index)}
          onPriceChange={onPriceChange}
          onSelectPrice={onSelectPrice}
          onSecretKeyPress={onSecretKeyPress}
          />
      </section>

      <section className="abed-section-left">

        <ProductPicker query={buscarProducto} onChooseProduct={onChooseProduct}/>
        <div className='abed-ingresar_cliente mt-2 mb-2'> 
            <input className='abed-DocCliente' type="text" placeholder='Buscar Producto' value={buscarProducto} onChange={e => setBuscarProducto(e.target.value)} />
        </div>
      </section>

      <footer>
        <div className='d-flex flex-column align-items-center gap-2 w-100'>
          <div className='total__container'>
            {isGreaterThanZero(totales.Gravado) && (
              <p>Gravado <strong> S/ {formatSoles(totales.Gravado)}</strong></p>
            )}
            
            {isGreaterThanZero(totales.Inafecto) && (
              <p>Inafecto <strong> S/ {formatSoles(totales.Inafecto)}</strong></p>
            )}
            
            {isGreaterThanZero(totales.Exonerado) && (
              <p>Exonerado <strong> S/ {formatSoles(totales.Exonerado)}</strong></p>
            )}
            
            {isGreaterThanZero(totales.IGVPreventa) && (
              <p>IGV <strong> S/ {formatSoles(totales.IGVPreventa)}</strong></p>
            )}
            
            {isGreaterThanZero(totales.redondeo) && (
              <p>Redondeo <strong> S/ {formatSoles(totales.redondeo)}</strong></p>
            )}
            
            {isGreaterThanZero(totales.Gratuitas) && (
              <p>Gratuitas <strong> S/ {formatSoles(totales.Gratuitas)}</strong></p>
            )}
            
            {isGreaterThanZero(totales.ICBPERPreventa) && (
              <p>ICBPER <strong> S/ {formatSoles(totales.ICBPERPreventa)}</strong></p>
            )}
          </div>
          <div className='seccion2-footer d-flex flex-column flex-md-row align-items-center justify-content-between w-100'>
            <div className='sub__total mb-2 mb-md-0'>
              <label className=''>S/ {formatSoles(totales.totalMonto)}</label>
            </div>
            <div>
              { (client != null && 'IdCliente' in client && selectedProducts.length ) && 
                <span className='generar__button btn btn-primary' onClick={onGenerate}>
                  {isEdit ? "Actualizar" : "Generar"}
                </span> 
              }
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default PreventaMobile;